module.exports = __webpack_public_path__ + "assets/a4ee036ecbdd6a394c439906586f361c.png";